export type Props = {
  isLoading: boolean;
  modalTransferIsOpen: boolean;
  hasValueToAnticipate: boolean;
  fetchData: () => void;
  handleToggleTransferModal: () => void;
  handleToggleAnticipateModal: () => void;
};

export type TransferByInvoice = {
  approx_amount: number;
  status: boolean;
  transfer_key: string;
};

const idTestUsers = [27270338, 67143563, 59511643, 86635600, 37568074, 77835904];

export const idListWithdrawalComposition = [
  39964262,
  99835806,
  75383856,
  76343215,
  273925,
  11353757,
  87828620,
  95205933,
  91073099,
  83405331,
  ...idTestUsers,
];
